import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { DataValidationToggleButton } from 'features/kestrelViewer/ui/tools/dataValidation/components/DataValidationToggleButton'
import { DataValidationPanel } from 'features/kestrelViewer/ui/tools/dataValidation/DataValidationPanel'
import React from 'react'

export const DataValidationControl: React.FC = () => {
  const { dataValidationPanelOpen, setDataValidationPanelOpen } =
    useKestrelViewerContext()

  const handleToggle = () => {
    setDataValidationPanelOpen(!dataValidationPanelOpen)
  }

  const handleClose = () => {
    setDataValidationPanelOpen(false)
  }

  return (
    <>
      {!dataValidationPanelOpen && (
        <DataValidationToggleButton onClick={handleToggle} />
      )}
      {dataValidationPanelOpen && <DataValidationPanel onClose={handleClose} />}
    </>
  )
}
